import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, AlertTriangle } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
const supportedByLogos = [{
  name: 'United States',
  src: 'https://cdn.magicpatterns.com/uploads/cyL3waZdH6pBtTFuUdiqa5/Flag-with-Margin-768x546.png'
}, {
  name: 'US Mission to ASEAN',
  src: 'https://cdn.magicpatterns.com/uploads/fSkt9nDfPb1ozv7arthRbA/usm-asean-seal-color.png'
}, {
  name: '@america',
  src: 'https://cdn.magicpatterns.com/uploads/8uRoLb9zJQMN26LnCJs74h/Untitled.png'
}, {
  name: 'Biji-biji Initiative',
  src: 'https://cdn.magicpatterns.com/uploads/c3KzafrHA8zmPPqJzAGFLS/Biji-biji-Initiative-Logo-W.svg'
}];
export function Footer() {
  const {
    language,
    t
  } = useLanguage();
  return <footer key={`footer-${language}`} className="bg-primary-900 text-white mt-auto border-t-4 border-accent-600" data-id="element-83">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-84">
        {/* Brand Section */}
        <div className="mb-12" data-id="element-85">
          <div className="flex items-center space-x-2.5 mb-4" data-id="element-86">
            <div className="p-2 bg-white/10 rounded-xl border border-white/10" data-id="element-87">
              <Shield className="h-6 w-6 sm:h-7 sm:w-7 text-accent-400" data-id="element-88" />
            </div>
            <span className="font-bold text-lg sm:text-xl tracking-tight" data-id="element-89">
              genZAFE.org
            </span>
          </div>
          <p className="text-sm sm:text-base text-slate-200 leading-relaxed max-w-md" data-id="element-90">
            {t('footer.description')}
          </p>
        </div>

        {/* Navigation Grid - 4 Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 border-t border-white/10 pt-12" data-id="element-91">
          {/* Column 1: Tools & Resources */}
          <div data-id="element-92">
            <h3 className="font-semibold text-base sm:text-lg mb-4 text-gold-300" data-id="element-93">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-3" data-id="element-94">
              <li data-id="element-95">
                <Link to={`/${language}/check-scam`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-96">
                  {t('nav.checkScam')}
                </Link>
              </li>
              <li data-id="element-97">
                <Link to={`/${language}/cyber-quiz`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-98">
                  {t('nav.cyberQuiz')}
                </Link>
              </li>
              <li data-id="element-99">
                <Link to={`/${language}/report-template-generator`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-100">
                  {t('nav.reportTemplate')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Emergency & Reporting */}
          <div data-id="element-101">
            <h3 className="font-semibold text-base sm:text-lg mb-4 text-gold-300" data-id="element-102">
              {t('footer.emergencyReporting')}
            </h3>
            <ul className="space-y-3" data-id="element-103">
              <li data-id="element-104">
                <Link to={`/${language}/emergency-protocol`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-105">
                  {t('nav.emergency')}
                </Link>
              </li>
              <li data-id="element-106">
                <Link to={`/${language}/where-to-report`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-107">
                  {t('nav.whereToReport')}
                </Link>
              </li>
              <li data-id="element-108">
                <Link to={`/${language}/evidence-digital-safety`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-109">
                  {t('nav.evidenceSafety')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Learn */}
          <div data-id="element-110">
            <h3 className="font-semibold text-base sm:text-lg mb-4 text-gold-300" data-id="element-111">
              {t('footer.learn')}
            </h3>
            <ul className="space-y-3" data-id="element-112">
              <li data-id="element-113">
                <Link to={`/${language}/education`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-114">
                  {t('nav.educationCenter')}
                </Link>
              </li>
              <li data-id="element-115">
                <Link to={`/${language}/international-framework`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-116">
                  {t('nav.internationalFramework')}
                </Link>
              </li>
              <li data-id="element-117">
                <Link to={`/${language}/events`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-118">
                  {t('nav.events')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: About */}
          <div data-id="element-119">
            <h3 className="font-semibold text-base sm:text-lg mb-4 text-gold-300" data-id="element-120">
              {t('footer.information')}
            </h3>
            <ul className="space-y-3" data-id="element-121">
              <li data-id="element-122">
                <Link to={`/${language}/about`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-123">
                  {t('nav.about')}
                </Link>
              </li>
              <li data-id="element-124">
                <Link to={`/${language}/disclaimer`} className="text-sm text-slate-200 hover:text-white hover:translate-x-1 transition-all inline-block" data-id="element-125">
                  {t('disclaimer.title')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Supported By Section */}
        <div className="pt-8 border-t border-white/10 mb-8" data-id="element-126">
          <h3 className="font-semibold text-base sm:text-lg mb-6 text-center text-slate-300 uppercase tracking-wider text-xs" data-id="element-127">
            {t('footer.supportedBy')}
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 lg:gap-8" data-id="element-128">
            {supportedByLogos.map(logo => <div key={logo.name} className="flex items-center justify-center p-3 sm:p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-129">
                <img src={logo.src} alt={logo.name} className="h-10 sm:h-12 lg:h-14 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" data-id="element-130" />
              </div>)}
          </div>
        </div>

        {/* Disclaimer Banner */}
        <div className="pt-8 border-t border-white/10" data-id="element-131">
          <div className="bg-gold-500/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-start space-y-3 sm:space-y-0 sm:space-x-4 mb-6 sm:mb-8 border border-gold-500/20" data-id="element-132">
            <AlertTriangle className="h-5 w-5 sm:h-6 sm:w-6 text-gold-400 flex-shrink-0 mt-0.5" data-id="element-133" />
            <p className="text-xs sm:text-sm text-slate-100 leading-relaxed" data-id="element-134">
              {t('footer.disclaimer')}
            </p>
          </div>
          <div className="text-center text-xs sm:text-sm text-slate-400 flex flex-col items-center gap-2" data-id="element-135">
            <span data-id="element-136">{t('footer.copyright')}</span>
            <span className="text-slate-500" data-id="element-137">{t('footer.tagline')}</span>
          </div>
        </div>
      </div>
    </footer>;
}